import "./LoadingLocationModal.scss";

import * as React from "react";

import { Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import Spinner from "../../Spinner";

type Props = {
    shouldShow: boolean;
};

export function LoadingLocationModal(props: Props) {
    return (
        <Modal className="sd-geolocation-loading-modal" show={props.shouldShow} onHide={() => undefined}>
            <Modal.Body className="container-fluid">
                <Spinner />
                <h3 className="sd-geolocation-text-header">
                    <FormattedMessage id={"SD_GEOLOCATION_LOADING"} />
                </h3>
            </Modal.Body>
        </Modal>
    );
}
